import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { API_PATH_ECOM_INVENTORY, API_PATH_ECOM_ORDER_INFO } from '@/api/apiRoutes'
import Page from '@/components/page/Page'
import {
  getActiveStep,
  HARDWARE_ORDER_STEP,
  setInventory,
  setOldOrderLines,
} from '@/ducks/hardwareReducer'
import { get } from '@/util/auth'

import Confirmation from './Confirmation'
import Inventory from './Inventory'
import OrderSummary from './OrderSummary'

import './hardware-orders.scss'

const HardwareOrders = () => {
  const dispatch = useDispatch()

  const fetchInventory = async () => {
    const inventory = await get(API_PATH_ECOM_INVENTORY)
    dispatch(setInventory(inventory))
  }

  const fetchOrderInfo = async () => {
    const oldOrderLines = await get(API_PATH_ECOM_ORDER_INFO)
    dispatch(setOldOrderLines(oldOrderLines))
  }

  useEffect(() => {
    fetchInventory()
    fetchOrderInfo()
  }, [])

  return (
    <Page className="hardware-orders">
      <h2 className="text-2xl">Hjemmekontor</h2>
      <OrderSummary />
      <ActiveStep />
    </Page>
  )
}

const ActiveStep = () => {
  const activeStep = useSelector(getActiveStep)

  switch (activeStep) {
    case HARDWARE_ORDER_STEP.CONFIRMATION:
      return <Confirmation />
    case HARDWARE_ORDER_STEP.INVENTORY:
    default:
      return <Inventory />
  }
}

export default HardwareOrders
